import { multipleBeacons } from 'app-webtech-core/beacon/multipleBeacons';
import { withFields } from 'app-webtech-core/beacon/withFields';

import {
  EPISODE_STARTS,
  EPISODE_ENDS,
  CLIP_STARTS,
  CLIP_ENDS,
  END_BUFFERING,
  START_BUFFERING,
  LOAD,
  CLICK_PLAY,
  CLICK_PAUSE,
  SET_ERROR,
  VOLUME_CHANGE,
  ENTERED_FULLSCREEN,
  EXITED_FULLSCREEN,
  VIDEO_BIT_RATE_CHANGE,
  VIDEO_LOADED_FOR_BI,
  SET_IS_VIDEO_REQUESTED,
} from '../actions/types';

import { episodeStartBeacon } from './episodeStart';
import { episodeEndBeacon } from './episodeEnd';
import { clipStartBeacon } from './clipStart';
import { clipEndBeacon } from './clipEnd';
import { playerBufferEndBeacon } from './playerBufferEnd';
import { playerBufferStartBeacon } from './playerBufferStart';
import { videoRequestBeacon } from './videoRequest';
import { videoErrorBeacon } from './videoError';
import { clickVolumeBeacon } from './clickVolume';
import { msnContentBufferingBeacon } from './msnContentBuffering';
import { msnVideoEndBeacon } from './msnVideoEnd';
import { msnVideoErrorBeacon } from './msnVideoError';
import { msnVideoStartBeacon } from './msnVideoStart';
import { enterFullScreenBeacon } from './enterFullScreen';
import { exitFullScreenBeacon } from './exitFullScreen';
import { videoLoadedBeacon } from './videoLoaded';
import { msnPlayerStartedBeacon } from './msnPlayerStarted';
import { videoBitRateChangeBeacon } from './videoBitRateChange';
import { clickPlayBeacon } from './clickPlay';
import { clickPauseBeacon } from './clickPause';

export const playerEventDefinitionsMap = {
  [EPISODE_STARTS]: multipleBeacons(withFields(episodeStartBeacon), msnVideoStartBeacon),
  [EPISODE_ENDS]: multipleBeacons(withFields(episodeEndBeacon), msnVideoEndBeacon),
  [CLIP_STARTS]: withFields(clipStartBeacon),
  [CLIP_ENDS]: withFields(clipEndBeacon),
  [START_BUFFERING]: multipleBeacons(
    withFields(playerBufferStartBeacon),
    msnContentBufferingBeacon,
  ),
  [END_BUFFERING]: withFields(playerBufferEndBeacon),
  [LOAD]: withFields(videoRequestBeacon),
  [SET_IS_VIDEO_REQUESTED]: withFields(videoRequestBeacon),
  [VIDEO_LOADED_FOR_BI]: multipleBeacons(withFields(videoLoadedBeacon), msnPlayerStartedBeacon),
  [CLICK_PLAY]: withFields(clickPlayBeacon),
  [CLICK_PAUSE]: withFields(clickPauseBeacon),
  [SET_ERROR]: multipleBeacons(withFields(videoErrorBeacon), msnVideoErrorBeacon),
  [VOLUME_CHANGE]: withFields(clickVolumeBeacon),
  [ENTERED_FULLSCREEN]: enterFullScreenBeacon,
  [EXITED_FULLSCREEN]: exitFullScreenBeacon,
  [VIDEO_BIT_RATE_CHANGE]: withFields(videoBitRateChangeBeacon),
};
